// Keep procurement prices consistent with the server's three-decimal HALF_UP rule.
export function roundPurchaseMoney(value) {
  const number = Number(value || 0)
  if (!Number.isFinite(number)) return 0
  const parts = Math.abs(number).toString().split('e')
  const shifted = Number(parts[0] + 'e' + (Number(parts[1] || 0) + 3))
  const rounded = Math.round(shifted)
  const result = Number(rounded + 'e-3')
  return number < 0 ? -result : result
}
